import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-redaction-icon]',
  template: `
    <svg:path
      d="M7.01562 14.5625L8.32812 13.25H14.9531L15.0781 13.2812L15.1406 13.2969L15.25 13.3594L15.3594 13.4375L15.4375 13.5469L15.5 13.6562L15.5312 13.7812L15.5469 13.9062L15.5312 14.0312L15.5 14.1562L15.4375 14.2656L15.3594 14.375L15.25 14.4531L15.1406 14.5156L15.0156 14.5469L14.8906 14.5625H7.01562ZM12 5.375L9.64062 3.01562L1.76562 10.8906V13.25H4.125L12 5.375ZM9.17188 1.625L9.28125 1.54688L9.39062 1.48438L9.51562 1.45312L9.64062 1.4375L9.76562 1.45312L9.89062 1.48438L10 1.54688L10.1094 1.625L13.4219 4.95312L13.5 5.0625L13.5469 5.1875L13.5781 5.3125V5.4375L13.5469 5.5625L13.5 5.6875L13.4219 5.79688L4.85938 14.375L4.75 14.4531L4.64062 14.5156L4.51562 14.5469L4.39062 14.5625H1.04688L0.921875 14.5312L0.859375 14.5156L0.75 14.4531L0.640625 14.375L0.5625 14.2656L0.5 14.1562L0.46875 14.0312L0.453125 13.9062V10.5625L0.484375 10.4375L0.5 10.375L0.5625 10.2656L0.640625 10.1562L9.17188 1.625Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedactionIcon {
  readonly viewBox = input<string>('0 0 16 16');
}
